// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import announcement02Icon from "@/assets/icons/announcement-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Announcement02IconProps = Omit<IconProps, "name">;

export function Announcement02Icon(props: Announcement02IconProps): React.ReactNode {
  return <Icon name={announcement02Icon} {...props} />;
}
